fragment OrgConfigForTenantFragment on OrgConfigForTenant {
  id
  config {
    branding {
      appName
      logoImage {
        src
        alt
        styles
      }
      gradients
      stockImagesDisabled
    }
    announcements {
      mapperNotification {
        message
        colour
        isActive
        visualTreatment
      }
      directoryNotification {
        message
        colour
        isActive
        visualTreatment
      }
    }
    featureFlags {
      enableWorkspaceSwitcher
      individualContactOptions {
        phone
        email
        microsoftTeams
      }
      designs {
        enableDesigns
      }
      enableGlobalSearch
      enableAiFeatures
    }
    aiCustomisations {
      abbreviationsRaw
    }
    locale
    currencySymbol
  }
  createdAt
  createdBy
}

fragment OrgConfigForWorkspaceFragment on OrgConfigForWorkspace {
  id
  config {
    branding {
      appName
      logoImage {
        src
        alt
        styles
      }
      gradients
    }
    slides {
      header {
        text
        align
      }
      footer {
        text
        align
      }
      showPageNumbers
    }
  }
  createdAt
  createdBy
}

query getOrgConfigForTenant {
  config: getOrgConfigForTenant {
    ...OrgConfigForTenantFragment
  }
}

query getOrgConfigForWorkspace {
  config: getOrgConfigForWorkspace {
    ...OrgConfigForWorkspaceFragment
  }
}

mutation updateOrgConfigForTenant($input: OrgConfigForTenantInput!) {
  config: updateOrgConfigForTenant(input: $input) {
    ...OrgConfigForTenantFragment
  }
}

mutation updateOrgConfigForWorkspace($input: OrgConfigForWorkspaceInput!) {
  config: updateOrgConfigForWorkspace(input: $input) {
    ...OrgConfigForWorkspaceFragment
  }
}

query getWorkspaceContextDocuments {
  docs: workspaceContextDocuments {
    id
    summary
    createdAt
  }
}

mutation deleteWorkspaceContextDocument($documentId: ID!) {
  deleted: deleteWorkspaceContextDocument(documentId: $documentId)
}

mutation addWorkspaceContextNote($text: String!) {
  note: addWorkspaceContextNote(text: $text) {
    id
    summary
    createdAt
  }
}
